<template>
  <input type="text" ref="date"
         :class="['date-picker', size]"
         :placeholder="placeholder"
         v-model="dateValue">
</template>

<script>
  export default {
    name: 'date-picker',
    props: {
      name: {
        type: String
      },
      value: {
        type: String
      },
      disabled: {
        default: false
      },
      next: {
        default: true
      },
      options: {
        type: Object,
        default () {
          return {}
        }
      },
      size: {
        type: String,
        default: function () {
          return 'hz-picker-md'
        }
      },
      placeholder: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    data: function () {
      return {
        dateValue: ''
      }
    },
    watch: {
      value: function (val) {
        var element = this.$el
        var datePicker = $(element).data('kendoDatePicker')
        if (val) {
          datePicker.value(val)
        }
      },
      disabled: function (val) {
        var element = this.$el
        var datePicker = $(element).data('kendoDatePicker')
        datePicker.enable(!val)
      }
    },
    methods: {
      setFields: function (fields) {
        this.fields = fields
      },
      onChange: function () {
        var datePicker = $(this.$el).data('kendoDatePicker')
        var value = moment(datePicker.value()).format('YYYY.MM.DD')
        if (value === 'Invalid date') {
          value = null
        }
        this.dateValue = value
        this.$emit('input', value)
      }
    },
    mounted: function () {
      // value 초기화
      const vm = this
      const element = this.$el
      const defaultOptions = {
        format: 'yyyy.MM.dd',
        change: this.onChange,
        disableDates: function (date) {
          // 오늘 이후 날짜 선택 가능여부, 기본적으로 선택 가능하고 next라는 값이 false로 들어올 경우 오늘 이후에 값은 선택 불가능
          if (!vm.next) {
            return (date && date.getTime() > (new Date()).getTime())
          }
        }
      }
      const mergerOptions = Object.assign(defaultOptions , this.options)
      let datePicker = null

      // Init DatePicker
      $(element).kendoDatePicker(mergerOptions)

      datePicker = $(element).data('kendoDatePicker')
      datePicker.enable(!this.disabled)

      // Input Box 클릭 시 날짜 선택 Dialog 활성화
      $(element).click(function() {
        datePicker.open()
      })

      if (this.value !== '') {
        datePicker.value(this.value)
      }
    }
  }
</script>

<style lang="scss">
  .date-picker {
    width: 100%;

    &.k-widget {
      color: $font-color;
    }

    .k-picker-wrap,
    .k-input {
      border-radius: 4px;
      box-shadow: none;
    }

    .k-state-disabled {
      .k-input, .k-select {
        background-color: #e9ecef;
      }
    }

    .k-state-focused,
    .k-autocomplete.k-state-default,
    .k-picker-wrap.k-state-default,
    .k-picker-wrap.k-state-default .k-input,
    .k-state-default > .k-select
    .k-numeric-wrap.k-state-default,
    .k-dropdown-wrap.k-state-default,
    .k-multiselect.k-header {
      box-shadow: none;
      border-color: $border-color;
    }
  }

  .hz-picker-lg {
    height: 48px;
    .k-input {
      height: 46px;
      width: calc(100% - 32px) !important;
      padding: 0 16px;
    }
    span {
      &.k-select {
        line-height: 46px;
      }
    }
  }

  .hz-picker-md {
     height: 32px;
    .k-input {
      height: 30px;
      width: calc(100% - 16px) !important;
      padding: 0 8px;
    }
  }

  .hz-picker-xs {
     height: 24px;
    .k-input {
      height: 22px;
      width: calc(100% - 8px) !important;
      padding: 0 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/DatePicker.vue